import { useState } from "react";
import { validateEmail, validatePassword } from "../utils/loginValidation";

export const useLoginForm = (onSubmit, propError, propLoading) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [localErrors, setLocalErrors] = useState({});
  const [generalError, setGeneralError] = useState("");

  const validate = () => {
    const emailError = validateEmail(email);
    const passwordError = validatePassword(password);

    const tempErrors = {};
    if (emailError) tempErrors.email = emailError;
    if (passwordError) tempErrors.password = passwordError;

    setLocalErrors(tempErrors);
    setGeneralError("");
    return Object.keys(tempErrors).length === 0;
  };

  const handleEmailChange = (value) => {
    setEmail(value);
    if (localErrors.email) {
      setLocalErrors((prev) => ({ ...prev, email: "" }));
    }
  };

  const handlePasswordChange = (value) => {
    setPassword(value);
    if (localErrors.password) {
      setLocalErrors((prev) => ({ ...prev, password: "" }));
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!validate()) return;
    onSubmit({ email, password });
  };

  return {
    email,
    password,
    showPassword,
    setShowPassword,
    localErrors,
    generalError,
    propError,
    propLoading,
    handleEmailChange,
    handlePasswordChange,
    handleSubmit,
  };
};
